<div class="question-holder trans-y-hide slideFromBottom w100">
  <div class="question regimen" (click)="openRegimenQueries(appConfig.Shared.Regimen.Class.FACE)">
    <img [src]="faceIconUrl" />
    <div class="text tw-uppercase" i18n="@@face">Face</div>
  </div>
  <div class="question regimen" (click)="openRegimenQueries(appConfig.Shared.Regimen.Class.HAIR)">
    <img class="hair" [src]="hairIconUrl" />
    <div class="text tw-uppercase" i18n="@@hair">Hair</div>
  </div>
</div>